import React from 'react';
import PropTypes from 'prop-types';
import ReactFlow, {
  Background,
  Controls,
  MiniMap,
} from 'reactflow';
import 'reactflow/dist/style.css';
import './FlowGraph.css';

/**
 * FlowGraph — Onyx-chrome wrapper around reactflow.
 * Use for omics pipelines and question-flow visualizers.
 */
export function FlowGraph({
  nodes = [],
  edges = [],
  onNodesChange,
  onEdgesChange,
  onConnect,
  fitView = true,
  showMiniMap = true,
  showControls = true,
  className = '',
  children,
  ...props
}) {
  return (
    <div
      className={['onyx-flow-graph', className].filter(Boolean).join(' ')}
      data-testid="onyx-flow-graph"
    >
      <ReactFlow
        nodes={nodes}
        edges={edges}
        onNodesChange={onNodesChange}
        onEdgesChange={onEdgesChange}
        onConnect={onConnect}
        fitView={fitView}
        proOptions={{ hideAttribution: true }}
        {...props}
      >
        <Background color="var(--color-border)" gap={16} />
        {showControls ? <Controls className="onyx-flow-graph__controls" /> : null}
        {showMiniMap ? (
          <MiniMap
            className="onyx-flow-graph__minimap"
            nodeColor="var(--color-text)"
            maskColor="var(--color-scrim)"
          />
        ) : null}
        {children}
      </ReactFlow>
    </div>
  );
}

FlowGraph.propTypes = {
  nodes: PropTypes.array,
  edges: PropTypes.array,
  onNodesChange: PropTypes.func,
  onEdgesChange: PropTypes.func,
  onConnect: PropTypes.func,
  fitView: PropTypes.bool,
  showMiniMap: PropTypes.bool,
  showControls: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default FlowGraph;
